import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Role } from '@app/store/shared/models';
import { CreateRoleValue, PermissionGroup, UpdateRoleValue } from '../models';

export const roleActions = createActionGroup({
    source: 'Role',
    events: {
        'Get Role': props<{ id: string }>(),
        'Get Role Success': props<{ payload: Role }>(),
        'Get Role Error': props<{ code: number }>(),

        'Get Permissions': emptyProps(),
        'Get Permissions Success': props<{ payload: PermissionGroup[] }>(),
        'Get Permissions Error': props<{ code: number }>(),

        'Create Role': props<{ value: CreateRoleValue }>(),
        'Create Role Success': emptyProps(),
        'Create Role Error': props<{ code: number }>(),

        'Update Role': props<{ id: string; value: UpdateRoleValue }>(),
        'Update Role Success': emptyProps(),
        'Update Role Error': props<{ code: number }>(),

        'Delete Role': props<{ id: string }>(),
        'Delete Role Success': emptyProps(),
        'Delete Role Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
